import {DropdownItemData} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';
import {Form} from '../../../stores/Form/Form';
import {ADPContextHandlers} from '../hook/useAdvDContextAPI';
import {MarkerType, RouteType} from '../types';

export type AdvancedDeliveryStateType = {
    isADPOpen: boolean;
    markers: MarkerType[];
    routes: RouteType[];
    selectedMarkers: MarkerType[] | null;
    planningForm: Form | null;
    routesForm: Form | null;
    isShowPlannedLocations: boolean;
    selectedLocations: number[];
    selectedDocumentType: DropdownItemData[];
    showAll: boolean;
};

export type AdvancedDeliveryContextType = AdvancedDeliveryStateType & Partial<ADPContextHandlers>;

export const defaultContext: AdvancedDeliveryContextType = {
    isADPOpen: false,
    isShowPlannedLocations: false,
    markers: [],
    routes: [],
    selectedMarkers: null,
    planningForm: null,
    routesForm: null,
    selectedDocumentType: [],
    selectedLocations: [],
    showAll: true
};
